/* eslint-disable max-len */
import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import moment from 'moment';
import { NgxTippyDefaultProps } from 'ngx-tippy-wrapper';
import RRule from 'rrule';
import { RecurringRouteService } from './recurring-route.service';
import { DispatchBoardService } from '../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { PickerSelectOptions, PickerSelectDisableOptions } from '../data-picker/data-picker.interface';
import { Subject, Subscription } from 'rxjs';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { HotToastService } from '@ngneat/hot-toast';
import { MatDialog } from '@angular/material/dialog';
import { RemoveJobComponent } from '../remove-job/remove-job.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { PreviewDataOptions } from '../preview-data/preview-data.interface';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'recurring-route-details',
  templateUrl: './recurring-route-details.component.html',
  styleUrls: ['./recurring-route-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecurringRouteDetailsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() recurringRouteUid: string;
  @Input() timezone: string = this.utilityService.timeZone;
  @Input() performAction?: string = null;
  @Output() actionEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('conflictDetailsDialogContent', { static: true }) conflictDetailsDialogContent: TemplateRef<any>;

  //General
  timeFormat: string = this.utilityService.timeFormat;
  dateFormat: string = this.utilityService.dateFormat;
  dateTimeFormat: string = this.utilityService.dateTimeFormat;
  maxAssigedToprofile: number = 4;
  dataPickerDetails = { openPicker: false, module: 'RECURRENCE_JOB_MASTER', filter: [] };
  jobPickerSubscription: Subscription;
  jobPickerOptions = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('route.add.job')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    disableSelected: true,
    selectOption: PickerSelectOptions.multiSelect,
    selectionDisableBasedOn: PickerSelectDisableOptions.GEOLOCATION,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    customParams: { 'filter.has_route': false, 'filter.frequency': null, 'filter.eligible_jobs': true, 'filter.route_start_date': null, 'filter.route_count': null, 'filter.route_end_date': null, 'filter.recurring_route_rule': null, 'filter.recurring_route_uid': null },
    dataConfig: null,
    filters: {
      enableCategory: true, enableShowAllJobs: true, enableAssignmentStatus: false, showRecurrenceMaster: true, dateRange: {
        enabled: true, hideCloseIcon: false
      }
    }
  };
  routeInstanceUserAssignmentTippyProps: NgxTippyDefaultProps = {
    allowHTML: true,
    theme: 'light',
    hideOnClick: false,
    trigger: 'click',
    interactive: true,
    appendTo: document.body,
    placement: 'right',
    zIndex: 100,
    onShow: (instance: any): any => {
      this.routeInstanceUserAssignTippyData.tippyRef = instance;
      this.routeInstanceUserAssignTippyData.onShow = true;
    },
    onHide: (): any => {
      this.routeInstanceUserAssignTippyData.prefillUsers = [];
      this.routeInstanceUserAssignTippyData.onShow = false;

    },
    onClickOutside: (instance: any, event: any) => {
      const ngSelectDropdown = document.querySelector('.ng-dropdown-panel');
      if (ngSelectDropdown && ngSelectDropdown.contains(event.target)) {
        return false; // Prevent onClickOutside for ng-select dropdown clicks
      }
      instance.hide();
    }
  };
  previewDrawer = { drawerOpen: false, module: null, moduleUID: '', parentRoute: null };
  previewDataOptions: PreviewDataOptions = {
    position: 'right',
    type: 'summary',
    mode: 'over',
    hasBackDrop: false,
    allowToEdit: this.dispatchBoardService.permissions.updateJob,
    menuOptions: {
      viewDetails: true,
      clone: this.dispatchBoardService.permissions.cloneJob,
      delete: this.dispatchBoardService.permissions.deleteJob
    }
  };

  //Recurring routes
  rrDetails: any;
  allRouteInstances = { pastInstances: [], upcomingInstances: [] };
  routeInstances: any[] = [];
  isLoading: boolean = true;
  recurringRouteListConflicts: any = {};
  recurringRouteInstanceConflict = { data: [], isLoading: false, isPanelOpen: false, dialogInstance: null };
  routeInstanceUserAssignTippyData = { routeUid: null, routeDetails: null, prefillUsers: [], tippyRef: null, type: null, onShow: null };
  // eslint-disable-next-line @typescript-eslint/naming-convention
  recurringRouteInstancePagination = { 'PAST': { page: 1, currentPage: 1, totalPages: 1, isLoading: false, totalRecords: 0, firstFetchCompleted: false }, 'UPCOMING': { page: 1, currentPage: 1, totalPages: 1, isLoading: false,  totalRecords: 0, firstFetchCompleted: false } };
  upcomingRouteInstanceDetails = { firstInstanceDeparture: null, totalCount: null };
  toggleViewRouteSeriesSubscription: Subscription;
  recurringRouteDetailsPerformActionSubscription: Subscription;
  editRoute = { routeFormOption: null, openRouteFormDrawer: false, data: null, isMasterRouteEdit: null };
// eslint-disable-next-line @typescript-eslint/naming-convention
  modeOfTransportIcon = { 'CAR': 'ti-car', 'TRUCK': 'ti-truck', 'BIKE': 'ti-bike', 'WALK': 'ti-walk', 'PEDESTRIAN': 'ti-walk' };
  //Navigation
  routeInstanceType: 'PAST' | 'UPCOMING' = 'UPCOMING';
  breadcrumbData = { right: { secondChild: null } };
  routeSeriesSegment = { isOpened: false };
  routeInstanceDetails = { routeDetails: null, isOpened: false, isLoading: false };
  cancelAllSubscriptions$ = new Subject<void>();

  constructor(
    private dataCollectorService: DataCollectorService,
    private localisationService: LocalisationService,
    private utilityService: UtilityService,
    private recurringRouteService: RecurringRouteService,
    private dispatchBoardService: DispatchBoardService,
    private _datapickerService: DataPickerService,
    private toastService: HotToastService,
    private matDialog: MatDialog,
    private zuperDialogService: ZuperDialogService
  ) { }

  @HostListener('scroll', ['$event'])
  routeInstanceScrollHandler(event: any): any {
    if (this.routeInstanceUserAssignTippyData.tippyRef) {
      this.routeInstanceUserAssignTippyData.tippyRef.hide();
    }
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.initDependencies();
    this.toggleViewRouteSeries(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('timezone' in changes) {
      this.updateTimezone();
    }
  }

  ngOnDestroy(): void {
    if (this.jobPickerSubscription?.unsubscribe) {
      this.jobPickerSubscription.unsubscribe();
    }
    if (this.toggleViewRouteSeriesSubscription?.unsubscribe) {
      this.toggleViewRouteSeriesSubscription.unsubscribe();
    }
    if (this.recurringRouteDetailsPerformActionSubscription?.unsubscribe) {
      this.recurringRouteDetailsPerformActionSubscription.unsubscribe();
    }
    this.cancelAllSubscriptions$.next();
  }

  //General
  initDependencies(): void {
    this.toggleViewRouteSeriesSubscription = this.dispatchBoardService.toggleRecurringRouteViewRouteSeriesSubject.subscribe((toggleState: boolean) => {
      this.toggleViewRouteSeries(toggleState);
    });
    let isActionOnInit: boolean = false;
    this.recurringRouteDetailsPerformActionSubscription = this.recurringRouteService.recurringRouteDetailsPerformAction.subscribe((event: any) => {
      const performAction: string = event?.performAction;
      if (performAction === 'ADD_JOB') {
        this.recurringRouteUid = event?.routeUid || this.recurringRouteUid;
        isActionOnInit = true;
        this.getRecurringRouteDetails((status: boolean) => {
          if (status) {
            this.openAddJobs(this.rrDetails);
          }
        });
      }
      else if (performAction === 'REFRESH_RR') {
        isActionOnInit = true;
        this.recurringRouteUid = event?.routeUid || this.recurringRouteUid;
        this.getRecurringRouteDetails();
      }
      else if (performAction === 'REFRESH_RR_INSTANCE') {
        isActionOnInit = true;
        const routeUid = this.routeInstanceDetails.routeDetails?.route_uid;
        this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
          if (routeUpdateStatus) {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
            if (updatedRouteDetails) {
              this.setRouteInstanceDetails(true, updatedRouteDetails, true);
            }
          }
        });
      }
    });
    if (!this.performAction) {
      this.getRecurringRouteDetails();
    }
    this.performAction = null;
  }

  dataPickerEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.dataPickerDetails.openPicker = false;
      if (this.jobPickerSubscription?.unsubscribe) {
        this.jobPickerSubscription.unsubscribe();
      }
    }
  }

  updateDynamicStyles(): void {
    //Set the styles after completion of DOM rendering (after ngAfterViewInit)
    setTimeout(() => {
      const descriptionElement = document.getElementById('master-route-description');
      const jobListElement = document.getElementById('master-route-job-list');
      if (descriptionElement && jobListElement) {
        jobListElement.style.maxHeight = Math.abs(Number(window.getComputedStyle(jobListElement).maxHeight.split('px')[0]) - Number(descriptionElement.offsetHeight) - 15) + 'px';
      }
    }, 500);
  }

  openAddJobs(rrDetails: any): void {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.dataPickerDetails.filter = (rrDetails?.recurring_jobs || []).map((job: any) => ({ ...job?.recurring_job, 'job_uid': job?.recurring_job?.recurring_job_uid }));
    const rrInstancesDepartureDates: any[] = [];
    const rruleOptions = RRule.fromString(this.rrDetails?.rrule);
    rruleOptions?.all()?.forEach((date) => {
      const parsedDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
      rrInstancesDepartureDates.push(parsedDate);
    });
    let parsedRrule: any = null;
    let frequency: string = null;
    if (this.rrDetails?.rrule) {
      parsedRrule = this.recurringRouteService.parseRrule(this.rrDetails?.rrule);
      frequency = RRule.FREQUENCIES[parsedRrule?.freq];
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.jobPickerOptions.dataConfig = {associateJobAfterCreation:true, assigned_to: this.rrDetails?.assigned_to || [], departure_dates: rrInstancesDepartureDates, duration: this.rrDetails?.route_duration, repeat: { type: this.rrDetails?.duration?.type, count: this.rrDetails?.duration?.value } };
    const routeEndDateFormatted = moment.tz(moment(this.rrDetails?.route_end).format('YYYY-MM-DD HH:mm:ss'), this.timezone).format('YYYY-MM-DD');
    // eslint-disable-next-line @typescript-eslint/naming-convention
    this.jobPickerOptions.customParams = { ...this.jobPickerOptions.customParams, 'filter.frequency': frequency || '',
       // eslint-disable-next-line @typescript-eslint/naming-convention
       'filter.route_start_date': this.upcomingRouteInstanceDetails.firstInstanceDeparture, 'filter.route_count': this.upcomingRouteInstanceDetails.totalCount,
       // eslint-disable-next-line @typescript-eslint/naming-convention
       'filter.route_end_date': routeEndDateFormatted, 'filter.recurring_route_rule': this.rrDetails?.rrule || '', 'filter.recurring_route_uid': this.rrDetails?.recurring_route_uid };
    this.dataPickerDetails.openPicker = true;
    this.jobPickerSubscription = this._datapickerService.onInit.subscribe(
      (res: any) => {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.dataPickerDetails.filter = res;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const oldJobAssignments = (rrDetails?.recurring_jobs || []).map((job: any) => ({ ...job?.recurring_job, 'job_uid': job?.recurring_job?.recurring_job_uid }));
        const addingJobInRecurringRouteToast = this.toastService.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updating', 'Updating Route Jobs'));
        this.recurringRouteService.updateRecurringRouteJobAssignments(rrDetails?.recurring_route_uid, oldJobAssignments || [], this.dataPickerDetails.filter,true, (completedStatus: any[]) => {
          addingJobInRecurringRouteToast.close();
          if (completedStatus.length) {
            this.getRecurringRouteDetails();
            this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'UPDATE_JOB_ASSIGNMENT' });
          }
        });
      }
    );
  }

  openJobPreviewDrawer(routeJob: any, routeDetails: any): void {
    const jobUid = routeJob?.job_uid || routeJob?.job?.job_uid;
    if (jobUid) {
      this.previewDataOptions.timeZone = this.timezone;
      this.previewDrawer.module = 'JOB';
      this.previewDrawer.moduleUID = jobUid;
      this.previewDrawer.parentRoute = routeDetails;
      this.previewDrawer.drawerOpen = true;
    }
  }

  previewDrawerEventHandler(event: any): any {
    const routeUid = this.previewDrawer.parentRoute?.route_uid;
    if (this.previewDrawer.module === 'JOB' && routeUid) {
      if (event.drawerClosed) {
        if (event?.action === 'UPDATE' || event?.action === 'DELETE') {
          this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
            if (routeUpdateStatus) {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
              if (updatedRouteDetails) {
                this.setRouteInstanceDetails(true, updatedRouteDetails, true);
              }
            }
          });
          this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'UPDATED_ROUTE_JOB' });
        }
        this.closePreviewDrawer();
      }
    }
  }

  closePreviewDrawer(): void {
    this.previewDrawer.drawerOpen = false;
    this.previewDrawer.moduleUID = '';
    this.previewDrawer.module = '';
    this.previewDrawer.parentRoute = null;
  }

  updateInstanceCount(): any {
    return {
      type: 'PRIMARY',
      displayKey: this.recurringRouteInstancePagination[this.routeInstanceType].totalRecords || '0',
      displayName: this.recurringRouteInstancePagination[this.routeInstanceType].totalRecords || '0',
      displayType: 'listingCount'
    };
  }

  //Recurring route master
  getRecurringRouteDetails(statusCallback?: (status: boolean) => void): void {
    if (this.recurringRouteUid) {
      const recurringRouteUrl = `${this.dataCollectorService.baseurl()}/routes/recurring/${this.recurringRouteUid}`;
      this.isLoading = true;
      this.dataCollectorService.getData(recurringRouteUrl).pipe(takeUntil(this.cancelAllSubscriptions$)).subscribe(
        (response: any) => {
          this.rrDetails = response?.data || {};
          this.rrDetails = this.formatRecurringRouteDetails(this.rrDetails);
          this.setRecurringRouteListConflicts();
          this.changeRouteInstanceType('UPCOMING', true, (status: boolean) => {
            if (statusCallback) {
              statusCallback(status);
            }
          });
          this.isLoading = false;
          this.updateDynamicStyles();
          this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'MAP_PAN_TO_ROUTE', data: response?.data || {} });
        },
        (error: any) => {
          this.isLoading = false;
          if (statusCallback) {
            statusCallback(false);
          }
        });
    }
  }

  formatRecurringRouteDetails(rrDetails: any): any {
    if (rrDetails) {
      if (rrDetails?.rrule && rrDetails?.route_end) {
        try {
          const rruleOptions = RRule?.fromString(rrDetails?.rrule);
          const routeEndDateFormatted = moment(rrDetails?.route_end).format('YYYY-MM-DD HH:mm:ss');
          const endDateUtcFormated = moment.tz(routeEndDateFormatted, 'UTC');
          const endDateReverseTzFormated = endDateUtcFormated.clone().tz(this.timezone).format('YYYY-MM-DDTHH:mm:ss');
          rruleOptions.options.until =  new Date(endDateReverseTzFormated);
          rrDetails['rrule_text'] = rruleOptions.toText();
        }
        catch {
          rrDetails['rrule_text'] = null;
        }
      }
      rrDetails['startLocation'] = this.recurringRouteService.getAddressText(rrDetails?.start_location);
      rrDetails['endLocation'] = this.recurringRouteService.getAddressText(rrDetails?.end_location);
      rrDetails['routeStartTime'] = this.recurringRouteService.formatDateTime(rrDetails?.route_start, this.timeFormat, this.timezone);
      rrDetails['primaryColor'] = rrDetails?.color || '#0172CB';
      rrDetails['secondaryColor'] = this.utilityService.getTextColorBasedOnBg(rrDetails?.color || '#0172CB');
      rrDetails['assigned_to_formatted'] = rrDetails?.assigned_to.map((assignee: any) => ({ ...assignee, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(assignee?.user?.profile_picture) }));
      if (rrDetails?.routes?.length) {
        rrDetails['routes'] = rrDetails?.routes.map((routeDetail: any) => ({
          ...routeDetail?.route,
        }));
      }
      if (rrDetails?.recurring_jobs.length) {
        rrDetails['recurring_jobs_details'] = _.orderBy(rrDetails?.recurring_jobs.map((jobDetail: any) => ({
          ...jobDetail?.recurring_job,
          sequence: jobDetail?.sequence,
          customerAddress: this.recurringRouteService.getAddressText(jobDetail.recurring_job?.customer_address),
          startTime: jobDetail.recurring_job?.job_start ? this.recurringRouteService.formatDateTime(jobDetail.recurring_job?.job_start, this.timeFormat, this.timezone) : null,
          endTime: jobDetail.recurring_job?.job_end ? this.recurringRouteService.formatDateTime(jobDetail.recurring_job?.job_end, this.timeFormat, this.timezone): null,
        })), 'sequence');
      }
    }
    return rrDetails;
  }

  editRouteInstance(routeDetails: any): any {
    if (routeDetails) {
      this.editRoute.routeFormOption = {
        state: 'edit',
        header: 'route.edit'
      };
      this.editRoute.openRouteFormDrawer = true;
      this.editRoute.isMasterRouteEdit = false;
      this.editRoute.data = routeDetails;
    }
  }

  cloneRouteInstance(routeDetails: any): any {
    if (routeDetails) {
      this.editRoute.routeFormOption = {
        state: 'clone',
        header: 'text.clone_route'
      };
      this.editRoute.openRouteFormDrawer = true;
      this.editRoute.isMasterRouteEdit = false;
      this.editRoute.data = routeDetails;
    }
  }

  onRouteFormDrawerClose(event: any): any {
    this.editRoute.openRouteFormDrawer = false;
    if (event.state === 'edit') {
      if (event.completed) {
        const recurringRouteMasterUid: string = event?.data?.recurring_route_uid;
        if(event.isMasterRouteEdit && recurringRouteMasterUid) {
          this.recurringRouteService.recurringRouteDetailsPerformAction.next({ performAction: 'REFRESH_RR', routeUid: recurringRouteMasterUid });
        }
        else {
          this.recurringRouteService.recurringRouteDetailsPerformAction.next({ performAction: 'REFRESH_RR_INSTANCE', routeUid: null });
        }
        this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'REFRESH_ROUTE' });
        this.editRoute.data = null;
      }
    }
  }

  //Recurring route instances
  getRecurringRouteInstances(routeInstanceType: 'PAST' | 'UPCOMING' = this.routeInstanceType, statusCompleted?: (status: boolean) => void): void {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const params = { 'page': this.recurringRouteInstancePagination[routeInstanceType].page, 'limit': 10, 'filter.recurring_route_uid': this.rrDetails?.recurring_route_uid, 'from_date': moment().format('YYYY-MM-DD'), 'get_past_routes': routeInstanceType === 'PAST', 'sort_by': 'departure', 'sort': routeInstanceType === 'PAST' ? 'DESC' : 'ASC' };
    this.recurringRouteInstancePagination[routeInstanceType].isLoading = true;
    const getRoutesUrl = `${this.dataCollectorService.baseurl()}/routes`;
    this.dataCollectorService.getData(getRoutesUrl, params).pipe(takeUntil(this.cancelAllSubscriptions$)).subscribe(
      (response: any) => {
        const routeInstances = this.formatRouteInstanceDetails(response?.data || []);
        if (routeInstanceType === 'PAST') {
          this.allRouteInstances.pastInstances = _.uniqBy([...this.allRouteInstances.pastInstances, ...routeInstances || []], 'route_uid');
        }
        else if (routeInstanceType === 'UPCOMING') {
          this.allRouteInstances.upcomingInstances = _.unionBy(this.allRouteInstances.upcomingInstances, routeInstances || [], 'route_uid');
        }
        this.routeInstances = routeInstanceType === 'PAST' ? this.allRouteInstances.pastInstances : this.allRouteInstances.upcomingInstances;
        this.recurringRouteInstancePagination[routeInstanceType].currentPage = response?.current_page || 1;
        this.recurringRouteInstancePagination[routeInstanceType].totalPages = response?.total_pages || 1;
        this.recurringRouteInstancePagination[routeInstanceType].totalRecords = response?.total_records || 0;
        this.recurringRouteInstancePagination[routeInstanceType].firstFetchCompleted = true;
        this.recurringRouteInstancePagination[routeInstanceType].isLoading = false;

        if (routeInstanceType === 'UPCOMING' && this.recurringRouteInstancePagination.UPCOMING.currentPage === 1 && this.recurringRouteInstancePagination.UPCOMING.totalRecords > 0 && response?.data?.length) {
          const firstUpcomingInstance: any = response?.data[0];
          if (firstUpcomingInstance?.departure) {
            this.upcomingRouteInstanceDetails.firstInstanceDeparture = moment.utc(firstUpcomingInstance?.departure).format('YYYY-MM-DD');
            this.upcomingRouteInstanceDetails.totalCount = this.recurringRouteInstancePagination.UPCOMING.totalRecords;
          }
        }
        this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'RECURRING_ROUTE_INSTANCES_LIST', data: [this.routeInstances?.[0]] });
        if (statusCompleted) {
          statusCompleted(true);
        }
      },
      (error: any) => {
        this.recurringRouteInstancePagination[routeInstanceType].isLoading = false;
        if (statusCompleted) {
          statusCompleted(false);
        }
      }
    );

  }

  updateRecurringRouteInstanceDetails(routeInstanceUid: any, targetInstanceType: 'PAST' | 'UPCOMING' = this.routeInstanceType, statusCallback?: (status: boolean) => void): void {
    if (routeInstanceUid) {
      const routeInstanceDetailsUrl = `${this.dataCollectorService.baseurl()}/routes/${routeInstanceUid}`;
      this.routeInstanceDetails.isLoading = true;
      this.dataCollectorService.getData(routeInstanceDetailsUrl).pipe(takeUntil(this.cancelAllSubscriptions$)).subscribe(
        (response: any) => {
          const routeDetails = this.formatRouteInstanceDetails([response?.data || {}])[0];
          if (targetInstanceType === 'PAST') {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const targetRouteIndex = _.findIndex(this.allRouteInstances.pastInstances, { 'route_uid': routeInstanceUid });
            if (targetRouteIndex !== -1) {
              this.allRouteInstances.pastInstances.splice(targetRouteIndex, 1);
              this.allRouteInstances.pastInstances.splice(targetRouteIndex, 0, routeDetails);
            }
          }
          else if (targetInstanceType === 'UPCOMING') {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            const targetRouteIndex = _.findIndex(this.allRouteInstances.upcomingInstances, { 'route_uid': routeInstanceUid });
            if (targetRouteIndex !== -1) {
              this.allRouteInstances.upcomingInstances.splice(targetRouteIndex, 1);
              this.allRouteInstances.upcomingInstances.splice(targetRouteIndex, 0, routeDetails);
            }
          }
          this.routeInstances = targetInstanceType === 'PAST' ? this.allRouteInstances.pastInstances : this.allRouteInstances.upcomingInstances;
          this.routeInstanceDetails.isLoading = false;
          statusCallback(true);
        },
        (error: any) => {
          this.routeInstanceDetails.isLoading = false;
          statusCallback(false);
        }
      );
    }
  }

  deleteRecurringRouteInstance(routeInstanceUid: string, targetInstanceType: 'PAST' | 'UPCOMING' = this.routeInstanceType): void {
    if (routeInstanceUid) {
      if (targetInstanceType === 'PAST') {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const targetRouteIndex = _.findIndex(this.allRouteInstances.pastInstances, { 'route_uid': routeInstanceUid });
        if (targetRouteIndex !== -1) {
          this.allRouteInstances.pastInstances.splice(targetRouteIndex, 1);
        }
      }
      else if (targetInstanceType === 'UPCOMING') {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const targetRouteIndex = _.findIndex(this.allRouteInstances.upcomingInstances, { 'route_uid': routeInstanceUid });
        if (targetRouteIndex !== -1) {
          this.allRouteInstances.upcomingInstances.splice(targetRouteIndex, 1);
        }
      }
      this.routeInstances = targetInstanceType === 'PAST' ? this.allRouteInstances.pastInstances : this.allRouteInstances.upcomingInstances;
      if (!this.routeInstances.length && this.recurringRouteInstancePagination[targetInstanceType].currentPage < this.recurringRouteInstancePagination[targetInstanceType].totalPages) {
        this.recurringRouteInstancePagination[targetInstanceType].page = 1;
        this.getRecurringRouteInstances(targetInstanceType);
      }
      this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'RECURRING_ROUTE_INSTANCES_LIST', data: [this.routeInstances?.[0]] });
      this.recurringRouteInstancePagination[this.routeInstanceType].totalRecords = Math.abs(this.recurringRouteInstancePagination[this.routeInstanceType].totalRecords - 1);
    }
  }

  loadMoreInstances(): void {
    if (this.recurringRouteInstancePagination[this.routeInstanceType].currentPage < this.recurringRouteInstancePagination[this.routeInstanceType].totalPages) {
      this.recurringRouteInstancePagination[this.routeInstanceType].page += 1;
      this.getRecurringRouteInstances();
    }
  }

  async setRecurringRouteListConflicts(): Promise<void> {
    if (this.rrDetails?.recurring_route_uid) {
      this.recurringRouteListConflicts = await this.recurringRouteService.getRecurringRouteListConflicts(this.rrDetails?.recurring_route_uid, this.timezone);
    }
  }

  async setRecurringRouteInstanceConflicts(): Promise<void> {
    this.recurringRouteInstanceConflict.data = [];
    this.recurringRouteInstanceConflict.isLoading = false;
    if (this.routeInstanceDetails.routeDetails?.route_uid) {
      this.recurringRouteInstanceConflict.isLoading = true;
      this.recurringRouteInstanceConflict.data = await this.recurringRouteService.getRecurringRouteInstanceConflicts(this.routeInstanceDetails.routeDetails, this.timezone);
    }
    this.recurringRouteInstanceConflict.isLoading = false;
  }

  formatRouteInstanceDetails(routeInstanceDetails: any): any[] {
    routeInstanceDetails = _.compact(routeInstanceDetails);
    routeInstanceDetails = routeInstanceDetails.map((routeInstanceDetail: any) => ({
      ...routeInstanceDetail,
      startLocation: this.recurringRouteService.getAddressText(routeInstanceDetail?.start_location),
      endLocation: this.recurringRouteService.getAddressText(routeInstanceDetail?.end_location),
      endLocationTravelData: {
        travelTime:  !_.isNil(routeInstanceDetail?.end_location?.time) ? this.utilityService.convertSecondsToHours(routeInstanceDetail?.end_location?.time || 0, true) : null,
        travelDistance:  !_.isNil(routeInstanceDetail?.end_location?.distance) ? (this.utilityService.getDistance(routeInstanceDetail?.end_location?.distance) || 0) + ' ' + this.recurringRouteService.distanceUnit : null
      },
      startEndTime: routeInstanceDetail?.departure && routeInstanceDetail?.route_end_time ? this.recurringRouteService.getStartEndTime(routeInstanceDetail?.departure, routeInstanceDetail?.route_end_time, false, this.timezone, true).join(' - ') : null,
      primaryColor: routeInstanceDetail?.color || '#0172CB',
      secondaryColor: this.utilityService.getTextColorBasedOnBg(routeInstanceDetail?.color || '#0172CB'),
      /* eslint-disable @typescript-eslint/naming-convention */
      assigned_to: routeInstanceDetail?.assigned_to.map((assignee: any) => ({ ...assignee, hasValidProfilePicture: this.utilityService.hasValidProfilePicture(assignee?.user?.profile_picture) })),
      jobs: _.orderBy(routeInstanceDetail?.jobs.map((job: any) => ({
        ...job,
        job_title: this.recurringRouteService.getTitle(job?.job?.prefix, job?.job?.work_order_number, job?.job?.job_title),
        travelData: {
          travelTime: !_.isNil(job?.time) ? this.utilityService.convertSecondsToHours(job?.time || 0, true) : null,
          travelDistance: !_.isNil(job?.distance) ? (this.utilityService.getDistance(job?.distance) || 0) + ' ' + this.recurringRouteService.distanceUnit : null
        },
        sequence: job?.sequence,
        isRecurrence: job?.is_recurrence || job?.job?.is_recurrence,
        isDelayedJob: job?.delayed_job || job?.job?.delayed_job,
        customer_addess: this.recurringRouteService.getAddressText(job?.job?.customer_address),
        startEndTime: job?.job?.scheduled_start_time && job?.job?.scheduled_end_time ? this.recurringRouteService.getStartEndTime(job?.job?.scheduled_start_time, job?.job?.scheduled_end_time, false, this.timezone).join(' - '): null,
      })), 'sequence')
      /* eslint-enable @typescript-eslint/naming-convention */
    }));
    return routeInstanceDetails;
  }

  updateRouteInstanceAssignedTo(routeInstance: any, type: 'recurringRoute' | 'oneOffRoute'): void {
    this.routeInstanceUserAssignTippyData.type = type;
    this.routeInstanceUserAssignTippyData.routeDetails = routeInstance;
    this.routeInstanceUserAssignTippyData.routeUid = routeInstance?.route_uid;
    this.routeInstanceUserAssignTippyData.prefillUsers = routeInstance?.assigned_to || [];
  }

  routeInstanceUserAssignEmitter(event: any): void {
    if (!event?.isConfirmed && this.routeInstanceUserAssignTippyData.tippyRef) {
      this.routeInstanceUserAssignTippyData.tippyRef.hide();
    }
    else if (event.isConfirmed) {
      const newAssignedUsers = event?.users || [];
      const oldAssignedUsers = this.routeInstanceUserAssignTippyData.routeDetails?.assigned_to;
      if (this.routeInstanceUserAssignTippyData.type === 'oneOffRoute') {
        const routeUid = this.routeInstanceUserAssignTippyData.routeDetails?.route_uid;
        this.recurringRouteService.updateRouteAssignments(routeUid, oldAssignedUsers, newAssignedUsers, true,(completedStatus: any[]) => {
          if (completedStatus.length) {
            this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
              if (routeUpdateStatus && this.routeInstanceDetails.isOpened) {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
                if (updatedRouteDetails) {
                  this.setRouteInstanceDetails(true, updatedRouteDetails, true);
                }
              }
            });
            this.setRecurringRouteListConflicts();
          }
        });
      }
      else if (this.routeInstanceUserAssignTippyData.type === 'recurringRoute') {
        const recurringRouteUid = this.routeInstanceUserAssignTippyData.routeDetails?.recurring_route_uid;
        this.recurringRouteService.updateRecurringRouteUserAssignments(recurringRouteUid, oldAssignedUsers, newAssignedUsers, false ,(completedStatus: any[]) => {
          if (completedStatus?.length) {
            this.getRecurringRouteDetails();
          }
        });

      }
      this.routeInstanceUserAssignTippyData.tippyRef.hide();
    }
  }

  updateTimezone(): void {
    this.rrDetails = this.formatRecurringRouteDetails(this.rrDetails);
    this.allRouteInstances.pastInstances = this.formatRouteInstanceDetails(this.allRouteInstances.pastInstances);
    this.allRouteInstances.upcomingInstances = this.formatRouteInstanceDetails(this.allRouteInstances.upcomingInstances);
    this.routeInstanceDetails.routeDetails = this.formatRouteInstanceDetails([this.routeInstanceDetails.routeDetails])[0];
    this.routeInstances = this.routeInstanceType === 'PAST' ? this.allRouteInstances.pastInstances : this.allRouteInstances.upcomingInstances;
  }

  routeInstanceContextMenuAction(action: 'DELETE' | 'ROUTE_LOCK', routeDetails: any, source: 'instanceListing' | 'detailsPage'): void {
    const routeUid: string = routeDetails?.route_uid;
    if (action === 'DELETE') {
      if (routeUid) {
        const deleteConfirmationDialogRef = this.dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'deleteRoute');
        deleteConfirmationDialogRef.afterClosed().subscribe((confirmationStatus: boolean) => {
          if (confirmationStatus) {
            const removeRouteInstanceToast = this.toastService.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_instance_removing', 'Removing route instance'));
            this.dispatchBoardService.deleteRoute(routeUid, (status: boolean) => {
              removeRouteInstanceToast.close();
              if (status) {
                this.deleteRecurringRouteInstance(routeUid);
                if (source === 'detailsPage') {
                  this.changeRouteInstanceType();
                }
                this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'DELETE_INSTANCE' });
              }
            });
          }
        });
      }
    }
    else if (action === 'ROUTE_LOCK') {
      if (routeUid && routeDetails) {
        const isRouteLocked = routeDetails?.is_locked;
        const lockStatus: 'unlockRoute' | 'lockRoute' = isRouteLocked ? 'unlockRoute' : 'lockRoute';
        const routeUnlockDialogref = this.dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, lockStatus);
        routeUnlockDialogref.afterClosed().subscribe((status: boolean) => {
          if (status) {
            const lockUpdateToast = this.toastService.loading(this.utilityService.getLocaleValue('route.lock.updating'));
            this.dispatchBoardService.updateRouteLock(routeUid, !isRouteLocked, (lockUpdateStatus: boolean) => {
              if (lockUpdateStatus) {
                this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
                  if (routeUpdateStatus && source === 'detailsPage') {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
                    if (updatedRouteDetails) {
                      this.setRouteInstanceDetails(true, updatedRouteDetails, true);
                    }
                  }
                });
                this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'ROUTE_LOCK' });
                lockUpdateToast.close();
              }
              else {
                lockUpdateToast.close();
              }
            });
          }
        });
      }
    }
  }

  removeJobFromRecurringRouteMaster(routeDetails: any, jobDetails: any, type: 'recurringRoute' | 'oneOffRoute'): void {
    if (type === 'recurringRoute') {
      const recurringRouteUid: string = routeDetails?.recurring_route_uid;
      const jobUid: string = jobDetails?.recurring_job_uid;
      if (recurringRouteUid && jobUid) {
        const removeRouteJobDialogref = this.dispatchBoardService.routeDetailsChangeConfirmationDialog(routeDetails, 'removeJob', { type: type, jobDetails: jobDetails });
        removeRouteJobDialogref.afterClosed().subscribe((status: boolean) => {
          if (status) {
            const removingJobInRecurringRouteToast = this.toastService.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updating', 'Updating Route Jobs'));
            this.recurringRouteService.deleteSingleJobInRecuuringRouteMaster(recurringRouteUid, jobUid, true, (removeStatus: boolean) => {
              removingJobInRecurringRouteToast.close();
              if (removeStatus) {
                this.getRecurringRouteDetails();
                this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'REMOVE_JOB_FROM_RR_MASTER' });
              }
            });
          }
        });
      }
    }
    else if (type === 'oneOffRoute') {
      const routeUid: string = routeDetails?.route_uid;
      const jobUid: string = jobDetails?.job_uid || jobDetails?.job?.job_uid;
      if (routeUid && jobUid) {
        const removeFromRoteConfirmationDialogRef = this.zuperDialogService.openCustom(RemoveJobComponent, {
          data: jobDetails,
          checkbox: true,
          extraClass: 'route-delete-dialog'
        });
        removeFromRoteConfirmationDialogRef.afterClosed()
          .subscribe((dialogData: any) => {
            if (dialogData) {
              const removeJobParam = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                jobs: [{ job_uid: jobUid }], unassign_users: dialogData?.unassign
              };
              this.dispatchBoardService.removeJobFromRoute(routeUid, removeJobParam, (status: true) => {
                if (status) {
                  this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
                    if (routeUpdateStatus) {
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
                      if (updatedRouteDetails) {
                        this.setRouteInstanceDetails(true, updatedRouteDetails, true);
                      }
                    }
                    this.setRecurringRouteListConflicts();
                    this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: true, isUpdated: true, action: 'REMOVE_JOB_FROM_ROUTE_INSTANCES' });
                  });
                }
              });
            }
          });
      }
    }
  }

  routeMasterContextMenuAction(action: 'EDIT' | 'DELETE', rrDetails: any): void {
    if (rrDetails) {
      if (action === 'EDIT') {
        this.editRoute.routeFormOption = {
          state: 'edit',
          header: 'route_master.edit'
        };
        this.editRoute.openRouteFormDrawer = true;
        this.editRoute.isMasterRouteEdit = true;
        this.editRoute.data = rrDetails;
      }
      else if (action === 'DELETE') {
        const routeName: string = rrDetails?.recurring_route_name || '';
        const recurringRouteUid: string = rrDetails?.recurring_route_uid;
        const jobCount: number = rrDetails?.recurring_jobs?.length || 0;
        const routeInstanceCount: number = this.upcomingRouteInstanceDetails?.totalCount || 0;
        let routeStart: string = null;
        let routeEnd: string = null;
        if (rrDetails?.route_start) {
          routeStart = moment.utc(rrDetails?.route_start).tz(this.timezone).format(this.dateTimeFormat);
        }
        if (rrDetails?.route_end) {
          routeEnd = moment.utc(rrDetails?.route_end).tz(this.timezone).format(this.dateTimeFormat);
        }
        const deleteConfirmationMessage: string = `${this.utilityService.getLocaleValue('route_master.delete.confirmation_message')} <span class="text-gray-900 font-medium">
          ${routeName}  ${routeStart && routeEnd ? `(${routeStart} - ${routeEnd})` : ''}</span> ? ${routeInstanceCount ? `<br><br><div class='flex gap-2'><i class='ti ti-exclamation-circle text-3xl'></i><span class='font-normal'>${this.utilityService.getLocaleValue('recurring_route.master_delete.instance_delete_info')} (${routeInstanceCount} ${this.utilityService.getLocaleValue('text.routes')}) and ${this.utilityService.getLocaleValue('recurring_route.master_delete.job_remove_info').toLowerCase()}</span></div>` : ''}`;
        const deleteConfirmationDialogRef = this.zuperDialogService.open({
          title: `${this.utilityService.getLocaleValue('text.delete_route_master', 'Delete Route Master')}`,
          message: deleteConfirmationMessage,
          type: 'error',
          actions: {
            confirm: {
              show: true,
              label: 'Ok',
              color: 'error',
              confirmDisplayKey: 'delete.text',
            },
            cancel: {
              show: true,
              label: 'Cancel'
            }
          },
          extraClass: 'timeoff-delete-dialog'
        });

        deleteConfirmationDialogRef.afterClosed().subscribe((status: boolean) => {
          if (status) {
            const removeRouteMasterToast = this.toastService.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_master_removing', 'Removing route master'));
            this.recurringRouteService.deleteRecurringRouteMaster(recurringRouteUid, true, (deletionStatus: boolean) => {
              if (deletionStatus) {
                this.emittActions({isClosed: true, isUpdated: true});
                removeRouteMasterToast.close();
              }
            });
          }
        });
      }
    }
  }

  openRouteInstanceWarningDialog(): void {
    this.recurringRouteInstanceConflict.dialogInstance = this.matDialog.open(this.conflictDetailsDialogContent, {
      panelClass: ['conflict-dialog'],
      disableClose: false,
      data: { conflicts: this.recurringRouteInstanceConflict?.data['conflicts'] || [], routeName: this.routeInstanceDetails.routeDetails?.route_name || '' }
    });
  }

  closeRouteInstanceWarningDialog(): void {
    if (this.recurringRouteInstanceConflict.dialogInstance) {
      this.recurringRouteInstanceConflict.dialogInstance.close();
    }
  }

  optimizeRouteInstance(routeDetails: any, source: 'instanceListing' | 'detailsPage'): void {
    const routeUid: string = routeDetails?.route_uid;
    const isRouteOptimized: boolean = routeDetails?.is_optimized;
    const isRouteLocked: boolean = routeDetails?.is_locked;
    if (routeUid && !isRouteLocked && !isRouteOptimized && routeDetails?.jobs?.length) {
      const routeOptimizeUrl = `${this.dataCollectorService.baseurl()}/routes/${routeUid}/optimize`;
      const loader = this.toastService.loading(this.utilityService.getLocaleValue('loader.route_optimise'));
      this.dataCollectorService.postData(routeOptimizeUrl, {})
        .pipe(takeUntil(this.cancelAllSubscriptions$))
        .subscribe((res: any) => {
          loader.close();
          if (res?.message) {
            this.toastService.success(res?.message);
          }
          this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
            if (routeUpdateStatus && source === 'detailsPage') {
              // eslint-disable-next-line @typescript-eslint/naming-convention
              const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
              if (updatedRouteDetails) {
                this.setRouteInstanceDetails(true, updatedRouteDetails, true);
              }
            }
          });
        }, (err: any) => {
          loader.close();
        });
    }
  }

  //Navigation
  changeRouteInstanceType(routeInstanceType?: 'PAST' | 'UPCOMING', forceGetRouteInstanceList: boolean = false, statusCompleted?: (status: boolean) => void): void {
    if (!routeInstanceType) {
      if (this.routeInstanceDetails.isOpened) {
        routeInstanceType = this.routeInstanceType;
      }
      else if (this.routeInstanceType === 'PAST') {
        routeInstanceType = 'UPCOMING';
      }
    }
    this.routeInstanceType = routeInstanceType || this.routeInstanceType || 'UPCOMING';
    if (forceGetRouteInstanceList) {
      this.allRouteInstances.pastInstances = [];
      this.allRouteInstances.upcomingInstances = [];
      this.recurringRouteInstancePagination.PAST.page = 1;
      this.recurringRouteInstancePagination.UPCOMING.page = 1;
    }
    this.routeInstances = routeInstanceType === 'PAST' ? this.allRouteInstances.pastInstances : this.allRouteInstances.upcomingInstances;
    if (!this.routeInstances.length) {
      this.getRecurringRouteInstances(this.routeInstanceType, (status: boolean) => {
        if (statusCompleted) {
          statusCompleted(status);
        }
      });
    }
    else {
      this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'RECURRING_ROUTE_INSTANCES_LIST', data: [this.routeInstances?.[0]] });
    }
    if (this.routeInstanceType === 'PAST') {
      this.breadcrumbData.right.secondChild = this.utilityService.getLocaleValue('recurring_route.past_instances', 'Past Instances');
    }
    else if (this.routeInstanceType === 'UPCOMING') {
      this.breadcrumbData.right.secondChild = null;
    }
    this.routeInstanceDetails.isOpened = false;
  }

  toggleViewRouteSeries(isOpened: boolean): void {
    if (this.routeSeriesSegment.isOpened !== isOpened) {
      this.routeSeriesSegment.isOpened = isOpened;
      this.dispatchBoardService.recurringRouteDetails.routeSeriesSegment.isOpened = isOpened;
      this.emittActions({ isClosed: false, isRouteInstanceSegmentOpen: this.routeSeriesSegment.isOpened });
    }
  }

  setRouteInstanceDetails(isOpend: boolean, routeInstanceDetails: any, forceUpdate: boolean = false): void {
    if (this.routeInstanceDetails.isOpened !== isOpend || forceUpdate) {
      this.routeInstanceDetails.isOpened = isOpend;
      if (this.routeInstanceDetails.isOpened && routeInstanceDetails) {
        this.routeInstanceDetails.routeDetails = routeInstanceDetails;
        this.breadcrumbData.right.secondChild = routeInstanceDetails?.route_name || '';
        this.setRecurringRouteInstanceConflicts();
      }
      else {
        this.routeInstanceDetails.routeDetails = null;
        this.breadcrumbData.right.secondChild = null;
      }
    }
  }

  openRouteInstance(isOpend: boolean, routeInstanceDetails: any): void {
    const routeUid: string = routeInstanceDetails?.route_uid;
    this.routeInstanceDetails.isOpened = isOpend;
    if (routeUid) {
      this.updateRecurringRouteInstanceDetails(routeUid, this.routeInstanceType, (routeUpdateStatus: boolean) => {
        if (routeUpdateStatus) {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const updatedRouteDetails = _.find(this.routeInstances, { 'route_uid': routeUid });
          if (updatedRouteDetails) {
            this.setRouteInstanceDetails(isOpend, updatedRouteDetails, true);
          }
        }
      });
      this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'RECURRING_ROUTE_INSTANCES_LIST', data: [routeInstanceDetails] });
      this.dispatchBoardService.recurringRouteDetailsSubject.next({ action: 'MAP_PAN_TO_ROUTE', data: routeInstanceDetails });
    }
  }

  emittActions(event: any): void {
    this.actionEmitter.emit(event);
  }

  //Helpers
  routeInstanceTrackBy(index: any, item: any): any {
    return item?.route_uid;
  }
}
